import Axios from 'axios'


export const SistemaParalelo = Axios.create({
  baseURL: process.env.REACT_APP_SISTEMA_PARALELO_API
  // baseURL: ' https://sistema-paralelo-hml.herokuapp.com/api/v1/',
  // baseURL: 'https://sistema-paralelo.herokuapp.com/api/v1/',
  // baseURL: 'http://localhost:3000/api/v1/',
})

SistemaParalelo.interceptors.request.use(
  config => {
    const requestConfig = config

    /**
     * Get token from store if it's not null set the Authorization Bearer
     */
    return Promise.resolve(requestConfig)
  },
  error => {
    return Promise.reject(error)
  },
)

SistemaParalelo.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    return Promise.reject(error)
  },
)

export default SistemaParalelo
